import { Label } from "../label/Label";
import { Switch } from "./Switch";

const DoubleLabelSwitch = ({
  leftLabel,
  rightLabel,
  onCheckedChange,
  defaultChecked = false,
}) => {
  return (
    <div className="flex flex-row gap-x-4">
      <Label>{leftLabel}</Label>
      <Switch
        onCheckedChange={onCheckedChange}
        defaultChecked={defaultChecked}
      />
      <Label>{rightLabel}</Label>
    </div>
  );
};

export default DoubleLabelSwitch;